module.exports = __webpack_public_path__ + "static/media/One-size.b7af2601.png";